export default "__VITE_ASSET__B44rp_Io__"